// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  Approve: 'Approve.Default.label.ATTESTATIONS',
  'Confirm Manager': 'Confirmmanager.label.ATTESTATIONS',
  'Cancel Approval': 'APPROVE.CANCEL.ATTESTATIONS',
  'Cancel Manager Confirmation': 'CONFIRMMANAGER.CANCEL.ATTESTATIONS',
  'Auto Approved as child item is actioned': 'AUTO_APPROVE_MSG',
  More: 'CERTS_BULK_MORE',
};
